import { render, staticRenderFns } from "./SkillRadial.vue?vue&type=template&id=38582cb5&scoped=true"
import script from "./SkillRadial.vue?vue&type=script&lang=js"
export * from "./SkillRadial.vue?vue&type=script&lang=js"
import style0 from "./SkillRadial.vue?vue&type=style&index=0&id=38582cb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38582cb5",
  null
  
)

export default component.exports